import axios from "axios";
import { z } from "zod";
import { toast } from "../../../components/ui/use-toast";
import { CircleCheckBig } from "lucide-react";
const baseURL = process.env.REACT_APP_SERVER_URL;

export const getAllVideos = async () => {
  try {
    const response = await axios.get(`${baseURL}/api/videos`);
    return { videos: response.data.videos };
  } catch (error) {
    console.error(error);
  }
};

export const getAllPaginatedNews = async (page: number) => {
  try {
    const response = await axios.get(`${baseURL}/api/news/all?page=${page}`);
    return {
      news: response.data.news,
      count: response.data.count,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error(error);
  }
};

export const getNewsBySlug = async (slug: string) => {
  try {
    const response = await axios.get(`${baseURL}/api/news/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateVideo = async (formData: any, navigate: Function) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${baseURL}/api/videos/`,
      formData,
      config
    );
    if (response && response.status === 201) {
      toast({
        variant: "destructive",
        className: "bg-green-500 border border-green-500",
        description: (
          <div className="flex items-center">
            <CircleCheckBig className="mr-2" />
            <span className="first-letter:capitalize">{response.data.msg}</span>
          </div>
        ),
      });
      navigate("/admin-dashboard/mediatheque/videos");
    }
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const getVideoById = async (id: number) => {
  try {
    const response = await axios.get(`${baseURL}/api/videos/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const handleUpdateVideo = async (
  id: number,
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.patch(
      `${baseURL}/api/videos/${id}`,
      formData,
      config
    );
    if (response.data?.msg) {
      toast({
        variant: "destructive",
        title: "Opération réussie.",
        description: response?.data?.msg,
        className: "bg-green-500 border border-green-500",
      });
      navigate("/admin-dashboard/mediatheque/videos");
    }
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const deleteVideo = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    const response = await axios.delete(`${baseURL}/api/videos/${id}`, config);
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};
